import React from 'react'
import { NumberFormat } from '@lingui/macro'

import { DEFAULT_CURRENCY } from 'templates/signup/constants'

interface PriceProps {
  value?: number
  currencyCode?: EF.supportedCurrency
  minimumFractionDigits?: number
}

const Price = ({
  value = 0,
  currencyCode = DEFAULT_CURRENCY,
  minimumFractionDigits = 0,
}: PriceProps) => (
  <NumberFormat
    value={value}
    format={{
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits,
    }}
  />
)

export default Price
